import React from "react";
// countup
// import CountUp from 'react-countup';
// intersection observer hook
import { useInView } from "react-intersection-observer";
// motion
import { motion } from "framer-motion";
// variants
import { fadeIn } from "../variants";
import { Link } from "react-scroll";

const About = () => {
  // rajouter après ref, inView pour la version mise à jour
  const [ref] = useInView({
    threshold: 0.5,
  });
  return (
    <section className="section mt-16" id="about" ref={ref}>
      <div className="container mx-auto mb-11 ">
        <div
          className="flex flex-col gap-y-10 lg:flex-row lg:items-center
        lg:gap-x-20 lg:gap-y-0 h-screen"
        >
          {/* img */}
          <motion.div
            variants={fadeIn("right", 0.3)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 bg-about bg-contain bg-no-repeat
          h-[640px] mix-blend-lighten bg-top"
          ></motion.div>
          {/* text */}
          <motion.div
            variants={fadeIn("left", 0.5)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1"
          >
            <h2 className="h2 text-accent">A propos.</h2>
            <h3 className="h3 mb-4">
              Developpeuse web React, React Native et Node !
            </h3>
            <p className="mb-6">
              Développeuse web et mobile fullstack spécialisée en React, React
              Native et Node.js, je conçois des applications performantes,
              maintenables et orientées expérience utilisateur. J’ai travaillé
              près d’un an en startup chez Coode-nt, où j’ai contribué à la
              refonte du site web (React / Django) et au développement de
              Domisimpli, une solution RH web et mobile complète (Next.js /
              React Native / Django). Mon parcours combine formation intensive,
              expérience en agence et projets produits réels, avec une forte
              capacité d’adaptation aux nouvelles stacks. Je porte une attention
              particulière à la qualité du code, à l’architecture des projets et
              à la clarté des interfaces. Curieuse, rigoureuse et orientée
              produit, je souhaite m’investir dans une équipe technique pour
              contribuer à des projets concrets et évoluer en continu.
            </p>
            <div className="flex gap-x-8 items-center">
              <a href="mailto:priscildu49@hotmail.fr">
                <button className="btn btn-lg">Me Contacter</button>
              </a>
              <Link
                to="work"
                activeClass="active"
                smooth={true}
                spy={true}
                className="text-gradient btn-link cursor-pointer"
              >
                Mon Portfolio
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
